<script setup>
import rightArrow from "@/assets/images/arrow-right.svg";
import PuppyIconComponent from "@/views/components/PuppyIconComponent.vue";

defineProps({
  dogs: Array
})

defineEmits(['select'])

function goToDogsDetails(dog) {
  router.push({path: `/dogs/${dog.id}`});
}
</script>

<template>
  <div
      v-for="dog in dogs"
      :key="dog.id"
      class="dog-row tw-no-underline tw-text-black"
      :class="{
            'minor': dog.isMinor,
              'major': !dog.isMinor
      }"
      @click="$emit('select', dog.id)"
      :id="'dog-' + dog.id"
  >
    <div class="dog-row-title">
      <div class="dog-row-title-birthdate">
        {{ new Intl.DateTimeFormat('fr-FR').format(new Date(dog.birthdate)) }}
      </div>
      <div class="dog-row-title-name tw-flex tw-items-center">
        {{ dog.name }}

        <PuppyIconComponent
            v-if="dog.isMinor"
            class="tw-ml-2"
        />
      </div>
    </div>
    <div class="dog-row-img">
      <img
          class="recensement-row-icon"
          :src="rightArrow"
          alt="right-arrow"
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/css/_variables.scss";

.dog {
  display: flex;
  flex-direction: column;
  gap: 1em;
}

.dog-row {
  border: 1px solid $altGreen;
  border-radius: 20px;
  padding: 0.5em 0.7em;
  display: flex;
  align-items: center;
  //gap: 2em;
  justify-content: space-between;
  cursor: pointer;
  transition: 200ms;

  &:hover {
    border: 1px solid rgba(101, 159, 18, 0.3);
    box-shadow: 0 2px 15px 0 rgba(101, 159, 18, 0.3);
  }


  &-title {
    font-weight: bold;
    display: flex;
    line-height: 15px;
    align-items: center;
    gap: 1em;

    &-name {
      text-align: start;
      min-width: 950px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    &-sex {
      text-align: center;
      font-weight: 500;
      width: 70px;
      color: #667085;
    }

    &-birthdate {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $altGreen;
      padding: 0.7em 0.8em;
      border-radius: 16px;
      color: $green;
      font-size: 16px;
      width: 100%;
      height: 20px;
      font-weight: 400;

    }
  }

  &-img {
    background-color: $sand;
    padding: 0.7em 1em;
    border-radius: 16px;
    display: flex;
    align-items: center;

  }

}

.search-btn {
  width: 100%;
  text-decoration: none;
  padding: 0.5em 1em;
  text-align: center;
  background-color: #659F12;
  color: white;
  border-radius: 14px;
  margin-top: 1.5em !important;
}

.blured {
  filter: blur(4px)
}

.empty-dog {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-more {
  width: 100%;
  text-decoration: none;
  padding: 0.5em 1em;
  text-align: center;
  background-color: #659F12;
  color: white;
  border-radius: 20px;
  margin-top: 0.5em !important;
}

@media screen and (max-width: 650px) {
  .dog-row-title-name {
    font-weight: bold;
    max-width: 85px;
    min-width: 85px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

  }
}

.minor {
  .dog-row-title-birthdate {
    background-color: $altGreen;
    color: $green;
  }
}

.major {
  .dog-row-title-birthdate {
    background-color: $green;
    color: white;
  }
}

</style>